import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'apn-theme';

function preferredDark() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return saved === 'dark';
  } catch (e) {
    // Storage blocked: fall back to the system setting.
  }
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/**
 * The admin area is built for the light theme only. While on /admin* this keeps `html.dark` off
 * (even if something re-adds it), and restores the visitor's saved/system preference on the way out.
 */
export default function AdminThemeGuard() {
  const { pathname } = useLocation();
  const isAdmin = pathname === '/admin' || pathname.startsWith('/admin/');

  useEffect(() => {
    const root = document.documentElement;
    if (!isAdmin) {
      root.classList.toggle('dark', preferredDark());
      return undefined;
    }
    root.classList.remove('dark');
    const observer = new MutationObserver(() => {
      if (root.classList.contains('dark')) root.classList.remove('dark');
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, [isAdmin]);

  return null;
}
